module.exports = __webpack_public_path__ + "b821b84b9fcb347caf7f49d9c05aaef8.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/user/notes/edit/edit-note.html
// module id = 2264
// module chunks = 0